"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _nuiIntlRuntime = require("@concur/nui-intl-runtime");
var _Button = _interopRequireDefault(require("@concur/nui-widgets/lib/Buttons/Button"));
var _ConnectedMessage = _interopRequireDefault(require("./CocpapListingConnectionSection/sharedComponents/ConnectedMessage"));
var _ConnectButton = _interopRequireDefault(require("./CocpapListingConnectionSection/sharedComponents/ConnectButton"));
var _styles = require("../styles");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function UserListingConnectionSection(_ref) {
  var listing = _ref.listing,
    isDisabled = _ref.isDisabled,
    onConnectClick = _ref.onConnectClick,
    onDisconnectClick = _ref.onDisconnectClick,
    isConnecting = _ref.isConnecting;
  var _listing$core = listing.core,
    isUserConnected = _listing$core.isUserConnected,
    canUserConnect = _listing$core.canUserConnect,
    _listing$localized = listing.localized,
    _listing$localized2 = _listing$localized === void 0 ? {} : _listing$localized,
    connectURL = _listing$localized2.connectURL;
  var isMobileListing = connectURL === null || connectURL === void 0 ? void 0 : connectURL.includes('profile/profile_mobile.asp');
  return /*#__PURE__*/_react.default.createElement("div", {
    style: {
      textAlign: 'center'
    }
  }, isUserConnected && /*#__PURE__*/_react.default.createElement(_ConnectedMessage.default, null), !isUserConnected && canUserConnect && /*#__PURE__*/_react.default.createElement(_ConnectButton.default, {
    onClick: onConnectClick,
    disabled: isDisabled || isConnecting,
    renderSpinner: isConnecting,
    italicFont: isDisabled
  }), isUserConnected && !isMobileListing && /*#__PURE__*/_react.default.createElement(_Button.default, {
    onClick: onDisconnectClick,
    style: _styles.BUTTON_STYLE,
    innerProps: {
      className: 'max-button-width'
    }
  }, /*#__PURE__*/_react.default.createElement(_nuiIntlRuntime.FormattedMessage, {
    id: "Disconnect"
  })));
}
UserListingConnectionSection.propTypes = {
  listing: _propTypes.default.shape({
    core: _propTypes.default.shape({
      isUserConnected: _propTypes.default.bool.isRequired,
      canUserConnect: _propTypes.default.bool
    }).isRequired,
    localized: _propTypes.default.shape({
      connectURL: _propTypes.default.string
    })
  }).isRequired,
  isDisabled: _propTypes.default.bool,
  onConnectClick: _propTypes.default.func.isRequired,
  isConnecting: _propTypes.default.bool,
  onDisconnectClick: _propTypes.default.func.isRequired
};
var _default = exports.default = UserListingConnectionSection;